import { render, staticRenderFns } from "./BatteryChartBlock.vue?vue&type=template&id=355514a0&scoped=true"
import script from "./BatteryChartBlock.vue?vue&type=script&lang=js"
export * from "./BatteryChartBlock.vue?vue&type=script&lang=js"
import style0 from "./BatteryChartBlock.vue?vue&type=style&index=0&id=355514a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355514a0",
  null
  
)

export default component.exports